import { Pipe, PipeTransform } from "@angular/core";
import { DateTime } from "luxon";
import { ChargeMode, ChargingSchedulePeriod } from "src/shared/db_types";

const WEEKDAY_LABELS = {
  1: 'Mon',
  2: 'Tue',
  3: 'Wed',
  4: 'Thu',
  5: 'Fri',
  6: 'Sat',
  7: 'Sun'
}

export function formatMinutes(minutes: number): string {
  const h = Math.trunc(minutes / 60)
  const m = minutes % 60
  return `${h}h ${m}m`
}

// format minutes as "XX h YY m"
@Pipe({ name: 'formatMinutes'})
export class FormatMinutesPipe implements PipeTransform {
  transform(minutes: number): string {
    return formatMinutes(minutes)
  }
}

@Pipe({ name: 'formatKwh'})
export class FormatKwhPipe implements PipeTransform {
  transform(kwh: number): string {
    if (kwh < 10) {
      return kwh.toFixed(1)
    }
    return kwh.toFixed(0)
  }
}

@Pipe({ name: 'formatPercent'})
export class FormatPercentPipe implements PipeTransform {
  // percent is 0 to 100 (not 0 to 1)
  transform(percent: number): string {
    if (percent < 10) {
      return percent.toFixed(1)
    }
    return percent.toFixed(0)
  }
}

// format minutes-past-midnight using the locale eg '11:40 pm' or '23:40'
@Pipe({ name: 'formatMpm' })
export class FormatMpmPipe implements PipeTransform {
  transform(mpm?: number): string {
    if (mpm == undefined) {
      return '--:--'
    }
    const hh = Math.trunc(mpm / 60) % 24
    const mm = mpm % 60
    return DateTime.local(2020, 1, 1, hh, mm).toLocaleString(DateTime.TIME_SIMPLE)
  }
}

export function weekdaysDesc(weekdays?: number[]) {
  if (!weekdays || weekdays.length == 7) return 'Every Day'
  if (weekdays.length == 0) return 'No Days'
  let s = ''
  for (const d of weekdays) {
    s = s + WEEKDAY_LABELS[d] + ' '
  }
  s = s.trim()
  // TODO review these
  if (s == 'Sat Sun') {
    return 'Weekends'
  }
  if (s == 'Mon Tue Wed Thu Fri') {
    //return 'Weekdays'
    return 'Mon - Fri'
  }
  return s.trim()
}

// format a weekdays array as eg 'Every day', 'Weekdays', 'Mon Tue Wed' etc
@Pipe({ name: 'formatWeekdays' })
export class FormatWeekdaysPipe implements PipeTransform {
  transform(weekdays: number[] | undefined): string {
    return weekdaysDesc(weekdays)
  }
}

export function periodFunctionDesc(period: ChargingSchedulePeriod): string {
  if (period.chargeMode == ChargeMode.Off) {
    return 'Stop charging'
  }
  let desc = 'Charge'
  const ampsDesc = period.chargeAmps ? period.chargeAmps.toString() : 'max'
  desc += ` at ${ampsDesc} amps`
  if (period.chargeLimit) {
    desc += ` to ${period.chargeLimit}%`
  }
  return desc
}

@Pipe({ name: 'periodFunction' })
export class PeriodFunctionPipe implements PipeTransform {
  transform(period: ChargingSchedulePeriod): string {
    return periodFunctionDesc(period)
  }
}
